// src/component/AdminTopPagePreview.js
// 管理者だけが確認できる「擬似トップページ」
// 本家 TopPage とは完全に独立したコンポーネントのコピーを使用。
// 本家を編集してもこちらに影響なし、逆も同様。
import React, { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";

import PreviewMMInfoTabs from "./PreviewMMInfoTabs";
import PreviewTopPageMusicSection from "./PreviewTopPageMusicSection";

import { AppThemeContext } from "./AppShell";

import { doc, getDoc } from "firebase/firestore";
import { db } from "../api/firebase";

// 設定が無いときのフォールバック
const DEFAULT_TRACK = {
  id: "seasonal-track",
  title: "Seasonal MasterMind Track",
  src: "/audio/mm_seasonal_track.mp3",
};

export default function AdminTopPagePreview() {
  const theme = useContext(AppThemeContext) || {};
  const accent = theme.railActive || "#5A35FF";
  const softBg = theme.surfaceBg || "#FFFFFF";

  const [track, setTrack] = useState(DEFAULT_TRACK);
  const [loadingTrack, setLoadingTrack] = useState(true);

  // Firestore から「トップページ用の曲」を取得
  useEffect(() => {
    const fetchTrack = async () => {
      try {
        const ref = doc(db, "musicSettings", "topPageSeasonalTrack");
        const snap = await getDoc(ref);

        if (snap.exists()) {
          const data = snap.data();
          setTrack({
            id: data.trackId || "seasonal-track",
            title: data.title || DEFAULT_TRACK.title,
            src: data.src || DEFAULT_TRACK.src,
          });
        } else {
          setTrack(DEFAULT_TRACK);
        }
      } catch (e) {
        console.error("Failed to load seasonal track:", e);
        setTrack(DEFAULT_TRACK);
      } finally {
        setLoadingTrack(false);
      }
    };

    fetchTrack();
  }, []);

  return (
    <Box
      sx={{
        pt: 0.5,
        pb: { xs: 2, sm: 3 },
        px: { xs: 2, sm: 3 },
        minHeight: "100%",
        bgcolor: softBg,
        backgroundImage: `
          radial-gradient(circle at 0% 0%, ${accent}20 0, transparent 55%),
          radial-gradient(circle at 100% 100%, ${accent}10 0, transparent 60%)
        `,
        backgroundRepeat: "no-repeat",
        backgroundSize: "140% 140%",
        transition: "background 0.4s ease",
      }}
    >
      {/* 音楽セクション（OtohikariGlobe + プレーヤー + コミュニティフィード + 都道府県マップ） */}
      {!loadingTrack && <PreviewTopPageMusicSection track={track} />}

      {/* 情報タブ（最新情報・基本情報・動画） */}
      <Box sx={{ mt: 4 }}>
        <PreviewMMInfoTabs />
      </Box>
    </Box>
  );
}
